import ReactDOMServer from 'react-dom/server';

const isReactElementNull = (element) => {
	return !Boolean(ReactDOMServer.renderToStaticMarkup(element));
};

export default isReactElementNull;
